/** Durée de l'animation de lancer (alignée sur @keyframes dice-tumble). */
export const DICE_ROLL_DURATION_MS = 900;

export function createDiceCubeScene(extraClass = ''): HTMLDivElement {
  const scene = document.createElement('div');
  scene.className = extraClass ? `dice-cube-scene ${extraClass}` : 'dice-cube-scene';
  const cube = document.createElement('div');
  cube.className = 'dice-cube show-1';
  cube.setAttribute('aria-label', 'Dé');
  const faces = [
    { class: 'front', num: '1' },
    { class: 'back', num: '6' },
    { class: 'right', num: '2' },
    { class: 'left', num: '5' },
    { class: 'top', num: '3' },
    { class: 'bottom', num: '4' },
  ];
  faces.forEach(({ class: c, num }) => {
    const face = document.createElement('div');
    face.className = `dice-cube-face ${c}`;
    face.textContent = num;
    cube.appendChild(face);
  });
  scene.appendChild(cube);
  return scene;
}

export function getDiceCubeElement(scene: HTMLElement): HTMLDivElement | null {
  return scene.querySelector('.dice-cube');
}

export function setDiceCubeFace(scene: HTMLElement, value: number, animate: boolean): void {
  const cube = getDiceCubeElement(scene);
  if (!cube) return;
  const face = Math.max(1, Math.min(6, value));
  const faces = ['show-1', 'show-2', 'show-3', 'show-4', 'show-5', 'show-6'];
  if (animate) {
    cube.classList.remove(...faces);
    cube.classList.add('rolling');
    window.setTimeout(() => {
      cube.classList.remove('rolling');
      cube.classList.add(`show-${face}`);
    }, DICE_ROLL_DURATION_MS);
  } else {
    cube.classList.remove('rolling', ...faces);
    cube.classList.add(`show-${face}`);
  }
}
